import serviceConstants from './serviceConstants';


const defaultSuccessHandler = (callType, response) => console.log(`>>> ${callType} Success:`, response);
const defaultErrorHandler = (callType, response) => console.log(`>>> ${callType} Error:`, response);

const appService = {
    apiGetCountryCode: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiGetCountryCode', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiGetCountryCode', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_COUNTRY_CODE, {
            method: 'GET'
        }).then(response => response.length === 0 ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiQuery: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiQuery', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiQuery', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_QUERY, {
            data: {
                paymentRefNum: opts.paymentRefNum, 
                paymentCode: opts.paymentCode, 
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiLoginAsGuest: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiLoginAsGuest', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiLoginAsGuest', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_LOGIN_AS_GUEST, {
            data: {
                paymentCode: opts.paymentCode
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiLogin: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiLogin', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiLogin', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_LOGIN, {
            data: {
                paymentCode: opts.paymentCode, 
                loginMethod: opts.loginMethod, 
                mobileNum: opts.mobileNum, 
                mobileCountryCode: opts.mobileCountryCode, 
                email: opts.email, 
                password: opts.password,
                authCode: opts.authCode,
                refresh: opts.refresh || false,
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiLoginOtp: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiLoginOtp', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiLoginOtp', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_LOGIN_OTP, {
            data: {
                paymentCode: opts.paymentCode, 
                mobileNum: opts.mobileNum, 
                mobileCountryCode: opts.mobileCountryCode,
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiLoyaltyRevalidate: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiLoyaltyRevalidate', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiLoyaltyRevalidate', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_LOYALTY_REVALIDATE, {
            data: {
                paymentCode: opts.paymentCode,
                loyaltyType: opts.loyaltyType,
                secret: opts.secret,
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiLoyaltyRegisterInit: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiLoyaltyRegisterInit', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiLoyaltyRegisterInit', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_LOYALTY_REGISTER_INIT, {
            data: {
                paymentCode: opts.paymentCode,
                loyaltyType: opts.loyaltyType,
                memberId: opts.memberId,
                partnerRedirectUrl: opts.partnerRedirectUrl,
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiLoyaltyRequestOtp: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiLoyaltyRequestOtp', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiLoyaltyRequestOtp', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_LOYALTY_REQUEST_OTP, {
            data: {
                paymentCode: opts.paymentCode,
                loyaltyType: opts.loyaltyType,
                mobileCountryCode: opts.mobileCountryCode,
                mobileNum: opts.mobileNum,
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiAuthorise: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiAuthorise', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiAuthorise', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_AUTHORISE_TRANSACTION, {
            data: {
                paymentCode: opts.paymentCode,
                paymentRefNum: opts.paymentRefNum,
                userRefNum: opts.userRefNum,
                loginMethod: opts.loginMethod,
                mobileNum: opts.mobileNum,
                mobileCountryCode: opts.mobileCountryCode, 
                email: opts.email,
                password: opts.password,
                payments: opts.payments,
                txnPin: opts.txnPin,
                otpValue: opts.otpValue,
                authCode: opts.authCode,
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiResendOTP: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiResendOTP', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiResendOTP', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_RESEND_OTP, {
            data: {
                paymentCode: opts.paymentCode,
                paymentRefNum: opts.paymentRefNum,
                loginMethod: opts.loginMethod,
                mobileNum: opts.mobileNum,
                mobileCountryCode: opts.mobileCountryCode,
                email: opts.email,
                password: opts.password,
                authCode: opts.authCode,
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiCancelPayment: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiCancelPayment', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiCancelPayment', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_CANCEL_PAYMENT, {
            data: {
                paymentRefNum: opts.paymentRefNum,
                paymentCode: opts.paymentCode, 
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiTopUpOptions: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiTopUpOptions', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiTopUpOptions', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_TOPUP_OPTIONS, {
            data: {
                paymentCode: opts.paymentCode, 
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiTopUpRegister: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiTopUpRegister', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiTopUpRegister', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_TOPUP_REGISTER, {
            data: {
                paymentCode: opts.paymentCode, 
                loginMethod: opts.loginMethod, 
                mobileNum: opts.mobileNum, 
                mobileCountryCode: opts.mobileCountryCode, 
                email: opts.email, 
                password: opts.password,
                authCode: opts.authCode,
                amount: opts.amount,
                description: opts.description,
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiTopUpCancel: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiTopUpCancel', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiTopUpCancel', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_TOPUP_CANCEL, {
            data: {
                paymentRefNum: opts.paymentRefNum,
                paymentCode: opts.paymentCode, 
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiTopUpAuthorise: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiTopUpAuthorise', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiTopUpAuthorise', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_TOPUP_AUTHORISE, {
            data: {
                paymentCode: opts.paymentCode,
                userRefNum: opts.userRefNum,
                loginMethod: opts.loginMethod,
                mobileNum: opts.mobileNum,
                mobileCountryCode: opts.mobileCountryCode, 
                email: opts.email,
                password: opts.password,
                payments: opts.payments,
                txnPin: opts.txnPin,
                authCode: opts.authCode,
                paymentRefNum: opts.paymentRefNum,
                additionalData: opts.additionalData,
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },
    apiTxnPinUpdate: (opts) => {
        const onSuccess = !!opts.onSuccess
            ? opts.onSuccess
            : data => defaultSuccessHandler('apiTxnPinUpdate', data);

        const onError = !!opts.onError
            ? opts.onError
            : data => defaultErrorHandler('apiTxnPinUpdate', data);

        serviceConstants.fetchData(serviceConstants.ApiAddress.API_TXN_PIN_UPDATE, {
            data: {
                paymentCode: opts.paymentCode,
                loginMethod: opts.loginMethod,
                mobileNum: opts.mobileNum,
                mobileCountryCode: opts.mobileCountryCode, 
                email: opts.email,
                password: opts.password,
                authCode: opts.authCode,
                txnPin: opts.txnPin,
                confirmTxnPin: opts.confirmTxnPin,
            }
        }).then(response => !response.success ? onError(response) : onSuccess(response)
        ).catch(error => onError(error)
        );
    },

};

export default appService;